import React, { useEffect, useRef } from 'react';
import { Check } from 'lucide-react';
import { WIZARD_STAGES } from './uttSteps';

export const WizardStepper = ({ current, maxReached, onSelect, language }) => {
  const activeRef = useRef(null);
  useEffect(() => { activeRef.current?.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' }); }, [current]);
  return (
  <ol className="flex items-center gap-1 overflow-x-auto pb-1 no-scrollbar" data-testid="utt-wizard-stepper">
    {WIZARD_STAGES.map((s, i) => {
      const done = i < maxReached;
      const active = i === current;
      const reachable = i <= maxReached;
      return (
        <li key={s.id} ref={active ? activeRef : null} className={`flex items-center gap-1 ${active ? 'flex-[2] min-w-[110px]' : 'flex-1 min-w-[40px] sm:min-w-[96px]'}`}>
          <button
            type="button"
            disabled={!reachable}
            onClick={() => onSelect(i)}
            data-testid={`utt-stage-${s.id}`}
            className={`flex w-full items-center gap-2 rounded-xl px-2.5 py-2 text-left text-xs font-medium transition-colors duration-200 ${
              active ? 'bg-primary text-primary-foreground' : reachable ? 'bg-muted/60 text-foreground hover:bg-muted' : 'bg-muted/30 text-muted-foreground/60'
            }`}
          >
            <span className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-[10px] ${
              active ? 'bg-primary-foreground/20' : done ? 'bg-primary text-primary-foreground' : 'bg-background border border-border'
            }`}>
              {done && !active ? <Check className="h-3 w-3" /> : i + 1}
            </span>
            <span className={active ? '' : 'hidden sm:inline'}>{language === 'sw' ? s.sw : s.en}</span>
          </button>
        </li>
      );
    })}
  </ol>
  );
};
